import React from "react"
import { Edit } from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import ScheduleIcon from "@mui/icons-material/Schedule"
import Form from "./form"

function ObjectEdit(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "objects", icon: <ScheduleIcon/> },
    ]

    return (
        <Edit redirect="show" mutationMode="pessimistic" actions={<RecordActionsTabs subTabs={subTabs} />}>
            <Form />
        </Edit>
    )
}

export default ObjectEdit
